import { createMiddleware } from '@tanstack/react-start'
import { getDestination } from '../getDestination';

export const destinationMiddleware = createMiddleware({ type: 'function' })
    .server(async ({ next }) => {
        const destination = await getDestination();
        return next({
            context: {
                destination,
            },
        });
    })
